/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Caster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VariableType = 'string' | 'number' | 'bool' | 'list' | 'map';

export const VariableType = {
    String: 'string' as VariableType,
    Number: 'number' as VariableType,
    Bool: 'bool' as VariableType,
    List: 'list' as VariableType,
    Map: 'map' as VariableType
};

